import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'trustStyle', pure: true })
export class TrustStylePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer){}

  transform(value: string, ...args: unknown[]) {
    return this.sanitizer.bypassSecurityTrustStyle(value);
  }
}
